<template>
   <div class="container">
      <loading :active.sync="isLoading"></loading>

      <div v-if="(!cart || !cart.cartItems || cart.cartItems.length == 0) && (cat1_name!='')">
         請點選圖片訂購您要的產品喔~
      </div>
      <p v-if="cat1_name===''">系統加載中，請稍等...</p>
      <p v-if="cat1_name!=''">目前產品分類是:【 {{ cat1_name }} 】</p>

      <div class="row mt-0">
         <div
            class="col-4 mb-2 px-1"
            v-for="item in productInfos"
            :key="item.suuid"
         >
            <div class="card border-0 shadow-sm">
               <div
                  style="
                     height: 120px;
                     background-size: cover;
                     background-position: center;
                  "
                  :style="{ backgroundImage: `url(${item.imageUrl})` }"
                  @click="getProductInfo(item.suuid)"
               >
                  <div class="text-center">
                     <p class="text-light">
                        <!-- <p class="text-dark"> -->
                        <b>{{ item.name }}</b>
                     </p>
                  </div>
               </div>
               <!-- <div class="card-body">

                  <p>{{ item.name }}</p>
               </div>-->
               <!-- <span class="badge badge-secondary float-right ml-2">{{ item.cat1 }}</span> -->
               <!-- <div class="card-footer d-flex">
                  <button
                     type="button"
                     class="btn btn-outline-secondary btn-sm"
                     @click="getProductInfo(item.suuid)"
                  >
                     <i class="fas fa-spinner fa-spin" v-if="status.loadingItem === item.suuid"></i>
                     點選訂購
                  </button>
               </div>-->
            </div>
         </div>
      </div>
      <div
         class="modal fade"
         id="productInfoModal"
         tabindex="-1"
         role="dialog"
         aria-labelledby="exampleModalLabel"
         aria-hidden="true"
      >
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">
                     {{ productInfo.name }}
                  </h5>
                  <button
                     type="button"
                     class="close"
                     data-dismiss="modal"
                     aria-label="Close"
                  >
                     <span aria-hidden="true">&times;</span>
                  </button>
               </div>
               <div class="modal-body">
                  <img :src="productInfo.imageUrl" class="img-fluid" alt />
                  <blockquote class="blockquote mt-3">
                     <p class="mb-0">{{ productInfo.remark }}</p>
                     <footer class="blockquote-footer text-right">
                        【{{ cat1_name }}】 {{ productInfo.name }}
                     </footer>
                  </blockquote>
                  <div class="col" v-if="productInfo.short_description">
                     <div class="form-row">
                        <div class="form-group col-12">
                           {{ productInfo.short_description }}
                        </div>
                     </div>
                  </div>
                  <div class="col" v-if="productInfo.description">
                     <div class="form-row">
                        <div class="form-group col-12">
                           {{ productInfo.description }}
                        </div>
                     </div>
                  </div>
                  <div class="col" v-if="products && products.length >= 1">
                     <div class="form-row">
                        <div class="form-group col-12">
                           請在下面尺寸，填入幾包幾只：
                        </div>
                        <!-- <div class="form-group col-2"></div>
                        <div class="form-group col-2"></div>
                        <div class="form-group col-1"></div> -->
                     </div>
                     <div
                        class="form-row"
                        v-for="item in products"
                        :key="item.name"
                     >
                        <!-- {{item.pack=0}}
                        {{item.unpack_qty=0}}-->
                        <div class="form-group col-12">
                           <input
                              type="text"
                              class="form-control"
                              :id="item.name"
                              v-model="item.name"
                              readonly
                           />
                           <!-- <label class="col-form-label col-form-label-sm">{{item.name}}：</label> -->
                        </div>
                        <div class="form-group col-4">
                           <input
                              type="number"
                              class="form-control"
                              id="pack"
                              v-model.number="item.pack"
                              :placeholder="'包'"
                              vaule="0"
                           />
                           <!--:placeholder="'包('+[[item.package_qty]] +''" -->
                        </div>
                        +
                        <div class="form-group col-3">
                           <input
                              type="number"
                              class="form-control"
                              id="unpack_qty"
                              v-model.number="item.unpack_qty"
                              placeholder="只"
                              value="0"
                           />
                        </div>
                        <div class="form-group col-4">
                           <p>
                              =
                              {{
                                 parseInt(item.pack || 0) *
                                    parseInt(item.package_qty) +
                                 parseInt(item.unpack_qty || 0)
                              }}只
                           </p>
                        </div>
                     </div>
                  </div>

                  <!-- <select name class="form-control mt-3" v-model="selectedItemSuuid">
                     <option
                        :value="item.suuid"
                        v-for="item in products"
                        :key="item.name"
                     >選購 {{item.name}}(一包{{item.qtyInPackage}}個)</option>
                  </select>-->
               </div>
               <div class="modal-footer">
                  <!-- <div class="text-muted text-nowrap mr-3">
                     小計
                     <strong>{{ productInfo.num * productInfo.price }}</strong> 元
                  </div>-->
                  <button
                     class="btn"
                     data-dismiss="modal"
                     :disabled="isDisabled"
                  >
                     回上頁
                  </button>

                  <button
                     v-if="products && products.length >= 1"
                     type="button"
                     class="btn btn-primary"
                     @click="addtoCart()"
                     :disabled="isDisabled"
                  >
                     <!-- <i class="fas fa-spinner fa-spin" v-if="productInfo.id === status.loadingItem"></i> -->
                     加到購物車
                  </button>
               </div>
            </div>
         </div>
      </div>
      <div class="my-5 row justify-content-center">
         <div class="col-md-6" id="order">
            <!--訂購區-->
            <p v-if="cart && cart.cartItems && cart.cartItems.length >= 1">
               您訂購的產品如下:
            </p>

            <table
               class="table"
               v-if="cart && cart.cartItems && cart.cartItems.length >= 1"
            >
               <thead>
                  <th></th>
                  <th>品名</th>
                  <th>數量</th>
               </thead>
               <tbody>
                  <tr v-for="item in cart.cartItems" :key="item.suuid">
                     <td class="align-middle" style="width: 50px">
                        <button
                           type="button"
                           class="btn btn-outline-danger btn-sm"
                           @click="removeCartItem(item.suuid)"
                        >
                           <i class="far fa-trash-alt"></i>
                        </button>
                     </td>
                     <td class="align-middle">
                        {{ item.product_name }}
                        <!-- <div class="text-success" v-if="item.coupon">已套用優惠券</div> -->
                     </td>
                     <td class="align-middle" style="width: 100px">
                        <!-- {{ item.qty }} -->
                        <input
                           type="number"
                           class="form-control"
                           id="qty"
                           v-model="item.qty"
                           placeholder="數量"
                        />

                        <!-- <p>{{parseInt(item.pack)}}包{{item.unpack_qty||0}}個散裝，總共{{parseInt(item.pack||0)*parseInt(item.package_qty)+parseInt(item.unpack_qty||0)}}個</p> -->
                     </td>
                  </tr>
               </tbody>
               <tfoot>
                  <!-- <tr>
                     <td colspan="3" class="text-right">總計</td>
                     <td class="text-right">{{ cart.total }}</td>
                  </tr>
                  <tr v-if="cart.final_total !== cart.total">
                     <td colspan="3" class="text-right text-success">折扣價</td>
                     <td class="text-right text-success">{{ cart.final_total }}</td>
                  </tr>-->
               </tfoot>
            </table>
            <div class="col-md-12">
               <button
                  v-if="cart && cart.cartItems && cart.cartItems.length >= 1"
                  type="button"
                  class="btn btn-primary"
                  @click="goToFullfillRecipient()"
               >
                  填寫送貨/取貨資料
               </button>
            </div>
            <br />
            <div class="col-md-6">
               <button
                  v-if="cart && cart.cartItems && cart.cartItems.length >= 1"
                  type="button"
                  class="btn btn-danger"
                  @click="clearShoppingCart()"
               >
                  清空購物車
               </button>
            </div>
            <!-- <div class="col-md-6">
               <button
                  v-if="cart && cart.cartItems && cart.cartItems.length >= 1"
                  type="button"
                  class="btn btn-secondary"
                  @click="updateShoppingCart()"
               >
                  更新購物車
               </button>
            </div> -->
            <!-- <div class="input-group mb-3 input-group-sm">
               <input type="text" class="form-control" v-model="coupon_code" placeholder="請輸入優惠碼" />
               <div class="input-group-append">
                  <button
                     class="btn btn-outline-secondary"
                     type="button"
                     @click="addCouponCode"
                  >套用優惠碼</button>
               </div>
            </div>-->
         </div>
      </div>
   </div>
</template>

<script>
import $ from "jquery";

export default {
   data() {
      return {
         member: {},
         productInfos: [],
         productInfo: {},
         products: [],
         isDisabled: false,
         status: {
            loadingItem: "",
         },
         form: {
            member: {
               name: "",
               email: "",
               tel: "",
            },
            message: "",
            address: "",
         },
         cart: {},
         product: {},
         tempProduct: {},
         isLoading: false,
         //  coupon_code: "",
         //  memberSuuid: "GhMF9ngZBg65XCEmWkmU",
         selectedItemSuuid: "",
         cat1_id: "0001",
         cat1_name: "",
      };
   },
   methods: {
      jump() {
         this.$nextTick(() => {
            setTimeout(() => {
               //获取指定的div盒
               let targetbox = document.getElementById("order");
               //获取这个div盒的高度位置
               this.target = targetbox.offsetTop;
              //  console.log(this.target);
               //将滚动条定位到这个高度位置
               document.documentElement.scrollTop = this.target - 150;
            });
         });
      },
      async updateShoppingCart() {
         if (this.cart) {
            var updatedCartItems = [];
            for (let i in this.cart.cartItems) {
               var updatedCartItem = {};
               updatedCartItem.suuid = this.cart.cartItems[i].suuid;
               updatedCartItem.qty = parseInt(this.cart.cartItems[i].qty || 0);

               updatedCartItems.push(updatedCartItem);
            }
            var data = {
               memberAuth: {
                  suuid: this.member.suuid,
                  accessToken: this.member.accessToken,
               },
               cartItems: updatedCartItems,
            };
            await this.$ecServiceInstance
               .put(`/mall/shoppingCart/updatItems`, data)
               .then(() => {
                  this.getCart();
                  return true;
               });
         }
      },
      clearShoppingCart() {
         this.$ecServiceInstance
            .delete(`/mall/shoppingCart/cancelShoppingCart`, {
               data: {
                  memberAuth: {
                     suuid: this.member.suuid,
                     accessToken: this.member.accessToken,
                  },
               },
            })
            .then(() => {
               this.getCart();
            });
      },

      goToFullfillRecipient() {
         this.updateShoppingCart().then(() => {
            this.$router.push(`/customer/customer_checkout/`);
         });
      },
      getCat1_name(cat1_id) {
         return this.$ecServiceInstance
            .get(`/mall/store/getAllCat1s?id=${cat1_id}`)
            .then((response) => {
               var cat1 = null;
               if (response.data.data) {
                  cat1 = response.data.data[0];
                  return cat1.name;
               } else {
                  return "";
               }
            })
            .catch((e) => {
               console.error(e);
            });
      },

      getProductInfos(cat1) {
         const vm = this;
         //const userSuuid = localStorage.getItem("userSuuid");
         cat1 = cat1 || process.env.DEFAULT_CAT1 || "0001";
         this.getCat1_name(cat1);
         vm.isLoading = true;
         this.$ecServiceInstance
            .get(`/mall/store/getProductInfos?page_number=-1&cat1=${cat1}`)
            .then((response) => {
               this.productInfos = response.data.data;

               for (let i in this.productInfos) {
                  var image_url = this.productInfos[i].images[0].image_url;
                  this.productInfos[i].imageUrl = image_url;
               }
               vm.isLoading = false;
            });
      },
      getProductInfo(suuid) {
         const vm = this;
         vm.isLoading = true;

         var array = vm.productInfos;
         vm.status.loadingItem = suuid;
         //console.log('array:', array);
         for (let i in array) {
            if (array[i].suuid == suuid) {
               vm.productInfo = array[i];
               vm.status.loadingItem = "";
            }
         }
         this.$ecServiceInstance
            .get(
               "/mall/store/getProducts?page_number=-1&productInfo=" +
                  vm.productInfo.id
            )
            .then((response) => {

               vm.products = response.data.products;
               $("#productInfoModal").modal("show");
               vm.isLoading = false;

            });
      },

      findProductInProducts(productSuuid) {
         var vm = this;
         vm.isLoading = true;
         for (let i in vm.products) {
            if (vm.products[i].suuid == productSuuid) {
               vm.tempProduct = vm.products[i];
            }
         }
         vm.isLoading = false;
      },

      async addtoCart() {
         if (
            this.cart &&
            this.cart.cartItems &&
            this.cart.cartItems.length > 0
         ) {
            await this.updateShoppingCart();
         }

         const vm = this;
         vm.isDisabled = true;
         $("#productInfoModal").modal("hide");

         vm.isLoading = true;

         for (let i in vm.products) {
            var item = vm.products[i];
            if (item.pack || item.unpack_qty) {
               await this.$ecServiceInstance
                  .post("/mall/shoppingCart/addItem", {
                     memberAuth: {
                        suuid: this.member.suuid,
                        accessToken: this.member.accessToken,
                     },
                     cartItem: {
                        product_suuid: item.suuid,
                        product_id: item.id,
                        product_name: item.name,
                        product_list_price: item.list_price,
                        net_price: 0,
                        disc: 0,
                        activity_code: "",
                        qty:
                           parseInt(item.pack || 0) *
                              parseInt(item.package_qty) +
                           parseInt(item.unpack_qty || 0),
                        item_type: "Main",
                     },
                  })
                  .catch((e) => {
                     console.error(e);
                  });
            }
         }
         vm.getCart();

         vm.isDisabled = false;
         this.jump();
      },
      getCart() {
         //  const vm = this;
         this.isLoading = true;
         this.$ecServiceInstance
            .post("/mall/shoppingCart/get", {
               memberAuth: {
                  suuid: this.member.suuid,
                  accessToken: this.member.accessToken,
               },
            })
            .then((response) => {
               if (response) {
                  this.cart = response.data.shoppingCart;
               }
               this.isLoading = false;
            });
      },
      removeCartItem(suuid) {
         const vm = this;
         vm.isLoading = true;
         const body = {
            memberAuth: {
               suuid: this.member.suuid,
               accessToken: this.member.accessToken,
            },
            item: { suuid },
         };
         this.$ecServiceInstance
            .delete("/mall/shoppingCart/removeItem", {
               data: body,
            })
            .then(() => {
               vm.getCart();
               vm.isLoading = false;
            })
            .catch((e) => {
               console.error(e);
            });
      },

      //   createOrder() {
      //      const vm = this;
      //      //  const url = `${process.env.APIPATH}/api/${process.env.CUSTOMPATH}/order`;
      //      //  const order = vm.form;
      //      var confirmedCart = {};
      //      confirmedCart.memberSuuid = vm.memberSuuid;
      //      confirmedCart.contact_name = vm.form.member.name;
      //      confirmedCart.contact_tel = vm.form.member.tel;
      //      confirmedCart.contact_address = vm.form.address;
      //      confirmedCart.contact_message = vm.form.message;
      //      confirmedCart.itemsInCart = vm.cart.itemsInCart;

      //      this.$ecServiceInstance
      //         .post("/mall/checkOut/" + vm.memberSuuid, {
      //            //    form: vm.form,
      //            cart: confirmedCart,
      //         })
      //         .then((response) => {
      //            console.log("response", response);

      //            vm.$router.push(
      //               `/customer_checkout/` + response.data.order.suuid
      //            );
      //         })
      //         .catch((e) => {
      //            console.error(e);
      //         });
      //      //  this.form = {};
      //      //  this.cart = {};
      //   },
   },
   watch: {
      "$route.query.cat1_id": function (value, old) {
         this.getProductInfos(value);
      },
      "$route.query.cat1_name": function (value, old) {
         this.cat1_name = value;
      },
   },
   async created() {
      if (!localStorage.getItem("member")) {
         console.log("member logout");
         this.$router.push({ path: "/login" });
      }
      this.cat1_id = this.$route.query.cat1_id || process.env.DEFAULT_CAT1;
      this.cat1_name = await this.getCat1_name(this.cat1_id);
      this.getProductInfos(this.cat1_id);
      this.member = JSON.parse(localStorage.getItem("member"));
      this.getCart();
   },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/CustomerOrders.vue